module.exports = __webpack_public_path__ + "img/editSectionName.8929714a.svg";